export default __webpack_public_path__ + "static/media/StakingApplicationsIllustrationLight.1fbf381d.png";